import GameModel from "../../GameModel";
import GameStateControl from "../../GameStateControl";
import Totals from "../crew/Totals";
import GameTime from "../time/GameTime";
import MinedUpgradeCollection from "../upgrade/free/MinedUpgradeCollection";
import PickUpgradeCollection from "../upgrade/ore/PickUpgradeCollection";
import Values from "../value/Values";
import MinedUpgradeAutomation from "./MinedUpgradeAutomation";
import PickUpgradeAutomation from "./PickUpgradeAutomation";
import PrestigeAutomation from "./PrestigeAutomation";

export default class AutomationManager extends GameModel {
    /**
     * @param {MinedUpgradeCollection} minedUpgradeCollection
     * @param {PickUpgradeCollection} pickUpgradeCollection
     * @param {GameStateControl} gameStateControl
     * @param {Values} values
     * @param {Totals} totals
     * @param {GameTime} gameTime
     */
    constructor(minedUpgradeCollection, pickUpgradeCollection, gameStateControl, values, totals, gameTime) {
        super();
        
        /**
         * @constant
         * @type {GameTime}
         */
        this.gameTime = gameTime;

        /**
         * @constant
         * @type {MinedUpgradeAutomation}
         */
        this.minedUpgradeAutomation = new MinedUpgradeAutomation(gameTime, minedUpgradeCollection, values, gameTime);
        /**
         * @constant
         * @type {PickUpgradeAutomation}
         */
        this.pickUpgradeAutomation = new PickUpgradeAutomation(gameTime, pickUpgradeCollection, values, gameTime);
        /**
         * @constant
         * @type {PrestigeAutomation}
         */
        this.prestigeAutomation = new PrestigeAutomation(gameTime, values, gameStateControl, totals);
    }

    updateForTurn() {

        this.minedUpgradeAutomation.updateForTurn();
        this.pickUpgradeAutomation.updateForTurn();
        this.prestigeAutomation.updateForTurn();
    }

    /////////////////////////////////////////
    // GameModel
    /////////////////////////////////////////

    /**
     * @override
     */
    resetFull() {
        this.minedUpgradeAutomation.resetFull();
        this.pickUpgradeAutomation.resetFull();
        this.prestigeAutomation.resetFull();
    }

    /**
     * @override
     */
    resetForPrestige() {
        this.minedUpgradeAutomation.resetForPrestige();
        this.pickUpgradeAutomation.resetForPrestige();
        this.prestigeAutomation.resetForPrestige();
    }

}